import React from "react"
import Link from "next/link"

import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@coval/ui"
import { ArrowUpRight } from "lucide-react"

import type { DashboardTableCellDrillDownSelection } from "../hooks/useDashboardTableCellDrillDown"
import { UnifiedMetricDrillDownPanel } from "./UnifiedMetricDrillDownPanel"

interface DashboardTableCellDrillDownDrawerProps {
  selection: DashboardTableCellDrillDownSelection | null
  onClose: () => void
}

export const DashboardTableCellDrillDownDrawer: React.FC<
  DashboardTableCellDrillDownDrawerProps
> = ({ selection, onClose }) => (
  <Drawer
    open={!!selection}
    onOpenChange={(open) => {
      if (!open) {
        onClose()
      }
    }}
  >
    <DrawerContent
      size="lg"
      data-testid="dashboard-table-cell-drilldown-drawer"
    >
      <DrawerHeader
        actions={
          selection?.conversationsHref ? (
            <Button
              asChild
              variant="secondary"
              icon
              tooltip="Open filtered conversations in a new tab"
            >
              <Link
                href={selection.conversationsHref}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Open filtered conversations in a new tab"
              >
                <ArrowUpRight aria-hidden="true" />
              </Link>
            </Button>
          ) : null
        }
      >
        <DrawerTitle>
          {selection
            ? `${selection.clickData.displayLabel} results`
            : "Results"}
        </DrawerTitle>
      </DrawerHeader>
      {selection ? (
        <DrawerBody className="min-h-0 overflow-hidden p-0">
          <UnifiedMetricDrillDownPanel
            clickData={selection.clickData}
            baselineId={selection.baselineId}
            onClose={onClose}
          />
        </DrawerBody>
      ) : null}
    </DrawerContent>
  </Drawer>
)
